// Reparto en barras: planes, distritos, objetivos. Admite una segunda cifra
// por fila (la plata del mes de ese plan), que es lo que convierte un conteo
// en un dato de negocio: Nutrivital es el 78% de los clientes, pero no el 78%
// de la venta.

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { numero, soles } from './formato';
import { creceDesdeIzquierda, levanta } from './motion';

const NOMBRES = {
  LOSE: 'Bajar de peso',
  IMPROVE: 'Mejorar salud',
  GAIN: 'Subir de peso',
  SIN_PERFIL: 'Sin perfil completo',
};

export default function MixCard({ titulo, subtitulo, items, color = 'secondary', conMonto = false }) {
  if (!items || !items.length) return null;

  const mayor = Math.max(...items.map((i) => Number(i.clientes) || 0), 1);
  const total = items.reduce((a, i) => a + Number(i.clientes), 0);

  return (
    <Card sx={{ p: 3, height: 1, display: 'flex', flexDirection: 'column', ...levanta }}>
      <Typography sx={{ fontSize: 16, fontWeight: 600 }}>{titulo}</Typography>
      {subtitulo &&
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>{subtitulo}</Typography>
      }

      <Stack spacing={2} sx={{ mt: 2.5 }}>
        {items.map((item, i) => {
          const etiqueta = NOMBRES[item.etiqueta] || item.etiqueta;
          const parte = Math.round((Number(item.clientes) / (total || 1)) * 100);
          return (
            <Box key={item.etiqueta}>
              <Stack direction="row" justifyContent="space-between" spacing={2} sx={{ mb: .75 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {etiqueta}
                </Typography>
                <Stack direction="row" spacing={1} alignItems="baseline" sx={{ flexShrink: 0 }}>
                  {conMonto && item.monto !== null && item.monto !== undefined &&
                    <Typography sx={{ fontSize: 12.5, color: 'text.disabled' }}>
                      {soles(item.monto)}
                    </Typography>
                  }
                  <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{numero(item.clientes)}</Typography>
                  <Typography sx={{ fontSize: 12, color: 'text.disabled', width: 32, textAlign: 'right' }}>
                    {parte}%
                  </Typography>
                </Stack>
              </Stack>

              <Box sx={{ height: 9, borderRadius: 999, bgcolor: 'grey.200', overflow: 'hidden' }}>
                <Box
                  sx={{
                    height: 1, borderRadius: 999,
                    width: `${(Number(item.clientes) / mayor) * 100}%`,
                    background: (t) => `linear-gradient(90deg, ${t.palette[color].main}, ${t.palette[color].light})`,
                    ...creceDesdeIzquierda(i),
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Card>
  );
}
